import { object, string } from 'zod';

import { makeZodValidate as makeValidate } from '@occc-app/design-system';
import { IS_REQUIRED, isStringLengthUpTo } from '@occc-app/lib/constants/validationMessages';

export const CreateCommentFormValuesSchema = object({
  text: string({ required_error: IS_REQUIRED }).max(2000, isStringLengthUpTo(2000)),
});

export const CreateCommentFormValuesValidation = makeValidate(CreateCommentFormValuesSchema);
